export default __webpack_public_path__ + "static/media/5.c1cfa2a7.jpg";